import React from 'react';
import { Badge, Typography } from 'antd';

const { Text } = Typography;

const FiltersSummary = ({ totalCount, filtersCount }) => {
  if (filtersCount === 0) {
    return (
      <Text type="secondary">
        Total: {totalCount} clientes
      </Text>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Text type="secondary">
        Total: {totalCount} clientes
      </Text>
      <Badge 
        count={filtersCount} 
        style={{ backgroundColor: '#1890ff' }}
        title={`${filtersCount} filtro(s) aplicado(s)`}
      />
      <Text type="secondary" style={{ fontSize: '12px' }}>
        (com filtros aplicados)
      </Text>
    </div>
  );
};

export default FiltersSummary; 